import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'UIComponents/elements/headings';
import { useTranslations } from '../../hooks/useTranslations';
import CodeSplitEnvWrapper from '../common/env/CodeSplitEnvWrapper';
import commerceHubTranslations from 'i2l?query=sporks!pricing-pages-ui/lang/commerce-hub/en.lyaml';
import styled from 'styled-components';
import { Section } from '../common/SharedComponents';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { createContext } from 'react';
import { defaultTranslationsStatus } from '../../interfaces/TranslationsContext';
export const TranslationsContext = /*#__PURE__*/createContext(defaultTranslationsStatus);
const StyledHeadingWrapper = styled(Section).withConfig({
  displayName: "PaymentsProcessorsWrapper__StyledHeadingWrapper",
  componentId: "sc-1m1bb53-0"
})(["text-align:center;margin-top:32px;padding-bottom:24px;", ";"], breakpoint.tablet(_t || (_t = _`
      padding: 12px !important;
  `)));

const PaymentsProcessorsWrapper = ({
  isUnitedStates,
  paymentsAccountEligibility
}) => {
  const {
    isReady
  } = useTranslations(commerceHubTranslations);
  return /*#__PURE__*/_jsx(TranslationsContext.Provider, {
    value: {
      isReady
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex-column align-center justify-center",
      style: {
        width: '100%'
      },
      children: [/*#__PURE__*/_jsxs(StyledHeadingWrapper, {
        children: [/*#__PURE__*/_jsx(H2, {
          style: {
            fontWeight: 600
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "commerce-hub.paymentsProcessors.title"
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "m-top-2 text-align-center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "commerce-hub.paymentsProcessors.subtitle"
          })
        })]
      }), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
        authedComponentLoader: () => import(
        /* webpackChunkName: "authed-chunk" */
        `pricing-pages-ui/components/commerce-hub/InAppPaymentsProcessorsSection`),
        authedComponentProps: {
          isUnitedStates,
          paymentsAccountEligibility
        },
        publicComponentLoader: () => import(
        /* webpackChunkName: "public-chunk" */
        `pricing-pages-ui/components/commerce-hub/PublicPaymentsProcessorsSection`),
        publicComponentProps: {
          isUnitedStates
        }
      })]
    })
  });
};

export default PaymentsProcessorsWrapper;